import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import './EditContractTemplate.css';
import { updateTemplate } from '../../../../service/contractTemplate';
import { CONTRACT_TEMPLATE_TYPE } from '../../../../utils/constants';
import { useTranslation } from "react-i18next";

const EditContractTemplate = ({ template, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const [isLoading,setIsLoading]=useState(false);
  console.log("template to edit:::::::", template);
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      contractType: template?.contract_type || '',
      title: template?.boiler_pdf_name?.boiler_pdf_name || '',
      id:template?.id||null
    },
  });
  const [error, setError] = useState(null);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await updateTemplate(template.id, data,CONTRACT_TEMPLATE_TYPE, t);
      onSuccess();
      onClose();
    } catch (err) {
      setError(t("Failed to update the contract template. Please try again later."));
      reset({
        contractType: template.contract_type,
        title: template.boiler_pdf_name.boiler_pdf_name,
      });
    }finally{
      setIsLoading(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>{t("Update Contract Template")}</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-group">
            <label htmlFor="contractType">{t("Contract Type")}</label>
            <select id="contractType" {...register('contractType')} required disabled>
              <option value="">{t("Select a type")}</option>
              <option value="ZGLR">ZGLR</option>
              <option value="ZSI">ZSI</option>
            </select>
          </div>

          <div className="input-group">
            <label htmlFor="title">{t("Title")}</label>
            <input
              id="title"
              type="text"
              {...register('title')}
              disabled
            />
          </div>

          <div className="input-group">
            <label htmlFor="file">{t("File")}</label>
            <input
              id="file"
              type="file"
              {...register('file')}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button type="submit" className="submit-btn" disabled={isLoading}>{t("Submit")}</button>
            <button type="button" className="close-btn" onClick={onClose} disabled={isLoading}>{t("Close")}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContractTemplate;
